import posthog from 'posthog-js';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { apiEndpointToFullUrl } from 'utils/apiEndpointToFullUrl';
import { inferredTimeZone } from './posthogEvents';

export const usePostHog = (): void => {
  useEffect(() => {
    // Endpoint is our server and doesn't require an API key,
    // so we can use a dummy key here. Name of key will be visible in cookies.
    posthog.init('POSTHOG_KEY', {
      api_host: apiEndpointToFullUrl('/analytics/posthog'),
    });
  }, []);

  const location = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies(location.pathname): Reacts on pathname changes even when not using it
  useEffect(() => {
    posthog.capture('$pageview', { inferredTimeZone });
  }, [location.pathname]);
};
